"use client";

import { UserSvg } from "@/src/Asset";
import Image from "next/image";
import Link from "next/link";
import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import UniversalSearchbar from "@/src/Components/NavbarV2/UniversalSearchbar";
import UniversalSearchbarMobile from "@/src/Components/NavbarV2/component/MobileView/UniversalSearchbarMobileView";
import Discover from "@/src/Components/NavbarV2/Discover";
import { useGlobalContext } from "@/src/context/GlobalContext";
import LeadFormModal from "@/src/Components/ModalV2/LeadFormModal/LeadFormModal";
import ExploreMore from "@/src/Components/NavbarV2/ExploreMore";
import ExploreMoreMobile from "@/src/Components/NavbarV2/component/MobileView/ExploreMoreMobileView";
import navbardata from "@/src/JsonData/Navbar/navbardata.json";

const Navbar = ({ slugInfo }: any) => {
  const timer: number =
    Number(process.env.NEXT_PUBLIC_LEAD_FORM_TIMER) || 60000;
  const {
    isTransparent,
    isLeadFormOpen,
    setIsLeadFormOpen,
    setLeadFormData,
    isRelatedStudyAbroad,
  } = useGlobalContext();
  const [scroll, setScroll] = useState(true);
  const [isFormOpened, setIsFormOpened] = useState(false);
  const router = useRouter();
  const isBgTransparent = isTransparent && scroll;
  const slugData = slugInfo ? JSON.parse(JSON.stringify(slugInfo)) : null;
  // const [shouldDataFetch, setShouldDataFetch] = useState(false);

  const isStudyAbroad =
    router?.pathname.toLowerCase().includes("abroad") ||
    router?.asPath.toLowerCase().includes("abroad") ||
    isRelatedStudyAbroad ||
    (slugInfo && slugData?.country_name !== "India");

  const handleOpen = () => {
    setIsLeadFormOpen(!isLeadFormOpen);
    setLeadFormData({
      source: router?.asPath === "/" ? "homepage" : router?.asPath,
      title: isStudyAbroad ? "Study Abroad" : null,
    });
  };

  //   const streamsQueryParamsHomePage = useMemo(
  //     () => ({
  //       sort: "filter_sequence:asc",
  //       fields: ["stream_name", "filter_sequence"],
  //       populate: {
  //         exams: {
  //           publicationState: "live",
  //           sort: "display_sequence:asc",
  //           filters: {
  //             is_top: true,
  //             is_related_homepage: true,
  //           },
  //           fields: ["exam_name", "abbreviation", "exam_url"],
  //           populate: {
  //             exam_navbars: { fields: ["id", "title"] },
  //           },
  //         },
  //         geo_countries: {
  //           publicationState: "live",
  //           fields: ["country_name", "country_url", "display_name"],
  //           filters: { is_top: true },
  //         },
  //         college_names: {
  //           sort: "display_sequence:asc",
  //           publicationState: "live",
  //           filters: {
  //             is_top: true,
  //             is_related_homepage: true,
  //             country: {
  //               country_name: { $eqi: "India" },
  //             },
  //           },
  //           fields: [
  //             "college_name",
  //             "college_url",
  //             "abbreviation",
  //             "is_related_homepage",
  //             "display_sequence",
  //             "is_online_college",
  //           ],
  //           populate: {
  //             college_navbars: { fields: ["id", "title"] },
  //           },
  //           pagination: {
  //             page: 1,
  //             pageSize: 10,
  //           },
  //         },
  //         geo_states: {
  //           sort: "top_display_sequence:asc",
  //           fields: ["state_name", "state_url"],
  //           filters: {
  //             is_related_homepage: true,
  //             country: {
  //               country_name: { $eqi: "India" },
  //             },
  //           },
  //         },
  //         geo_cities: {
  //           fields: ["city_name", "city_url"],
  //           filters: {
  //             is_related_homepage: true,
  //             geo_country: {
  //               country_name: { $eqi: "India" },
  //             },
  //           },
  //         },
  //         courses: {
  //           sort: "display_sequence:asc",
  //           publicationState: "live",
  //           filters: {
  //             is_top: true,
  //             colleges: {
  //               country: {
  //                 country_name: { $eqi: "India" },
  //               },
  //               count: { $gt: 0 },
  //             },
  //           },
  //           fields: [
  //             "course_name",
  //             "abbreviation",
  //             "course_url",
  //             // "is_related_homepage",
  //           ],
  //         },
  //         publicationState: "live",
  //         pagination: {
  //           page: 1,
  //           pageSize: 25,
  //         },
  //       },
  //     }),
  //     []
  //   );

  //   const { data: streams } = useEntityData(
  //     "streams",
  //     streamsQueryParamsHomePage,
  //     shouldDataFetch
  //   );

  //   const streamData = streams?.data?.results;

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 50) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isTransparent]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (!isFormOpened) {
      timeoutId = setTimeout(() => {
        handleOpen();
        setIsFormOpened(true);
      }, timer);
    }
    return () => clearTimeout(timeoutId);
  }, [isFormOpened, timer]);

  return (
    <nav
      className={`fixed right-0 left-0 top-0 !z-[999] transition-colors duration-300 
       ${isTransparent && scroll ? "bg-transparent " : "bg-white shadow-sm"}`}
    >
      <div className="flex relative gap-x-4 items-center justify-between lg:justify-start w-full lg:mx-5 xl:max-w-full 3xl:max-w-screen-2xl 3xl:mx-auto h-[4rem] lg:h-[5.5rem] px-2">
        <section className="flex-1 flex items-center basis-1/3 h-full gap-x-2">
          {/* Mobile Hamburger icon */}
          <ExploreMoreMobile
            isBgTransparent={isBgTransparent}
            streamData={navbardata}
            // setShouldDataFetch={setShouldDataFetch}
          />
          {/* LOGO */}
          <Link href={isStudyAbroad ? "/study-abroad" : "/"}>
            <Image
              src={
                isTransparent && scroll
                  ? "/images/logo.png"
                  : "/images/collegehai_logo.png"
              }
              alt="Collegehai logo"
              title="Collegehai logo"
              width={160}
              height={60}
              priority
              className={`w-32 lg:w-40 h-8 lg:h-14 object-cover mt-2 -ml-2 lg:ml-0`}
              // unoptimized
            />
          </Link>
          <ExploreMore
            streamData={navbardata}
            isTransparent={isTransparent}
            scroll={scroll}
            // setShouldDataFetch={setShouldDataFetch}
          />
        </section>

        {/* Search Box */}
        <section className="flex items-center h-full lg:w-full gap-x-2">
          <UniversalSearchbar isTransparent={isTransparent} scroll={scroll} />
          <UniversalSearchbarMobile
            isTransparent={isTransparent}
            scroll={scroll}
          />
          {/* Discover */}
          <Discover
            isTransparent={isTransparent}
            scroll={scroll}
            isStudyAbroad={isStudyAbroad}
          />
          {/* Need Counselling Button */}
          <div>
            <button
              name="need_counselling"
              aria-label="need_counselling"
              onClick={handleOpen}
              className={` tracking-tight text-sm font-light font-inter lg:border-2 lg:px-4 lg:py-2 rounded-lg ml-2 2xl:ml-6 ${
                isTransparent && scroll
                  ? "text-white"
                  : "text-black lg:border-gray-400"
              }`}
            >
              <UserSvg className="lg:hidden scale-75 mt-1.5" />
              <span className="hidden lg:block"> Need Counselling?</span>
            </button>
            <LeadFormModal
              isOpen={isLeadFormOpen}
              setIsOpen={setIsLeadFormOpen}
              isStudyAbroad={isStudyAbroad}
            />
          </div>
        </section>
      </div>
    </nav>
  );
};

export default Navbar;
